import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { PapiUser, PapiDeviation } from '@wix/da-papi-types';

export const showReportModal = createAction(`${actionKey}.SHOW`, (deviation: PapiDeviation) => ({
  deviation,
}));

export const hideDeviation = createAction(
  `${actionKey}.HIDE_DEVIATION`,
  (deviationId: number) => deviationId
);
export const hideDeviationSuccess = createAction(
  `${actionKey}.HIDE_DEVIATION_SUCCESS`,
  (deviationId: number) => deviationId
);
export const hideDeviationFail = createAction(
  `${actionKey}.HIDE_DEVIATION_FAIL`,
  (deviationId: number) => deviationId
);

export const unhideDeviation = createAction(
  `${actionKey}.UNHIDE_DEVIATION`,
  (deviationId: number) => deviationId
);
export const unhideDeviationSuccess = createAction(
  `${actionKey}.UNHIDE_DEVIATION_SUCCESS`,
  (deviationId: number) => deviationId
);
export const unhideDeviationFail = createAction(
  `${actionKey}.UNHIDE_DEVIATION_FAIL`,
  (deviationId: number) => deviationId
);

export const blockDeviationAuthor = createAction(
  `${actionKey}.BLOCK_AUTHOR`,
  (user: PapiUser, deviationId: number) => ({ user, deviationId })
);
export const unblockDeviationAuthor = createAction(
  `${actionKey}.UNBLOCK_AUTHOR`,
  (userId: number, deviationId: number) => ({ userId, deviationId })
);
